<template>
    <vx-box-glass class="vx-text-slate-700 vx-font-sans">
        <vx-wallpaper :icon="faNotebook"></vx-wallpaper>
        <div class="vx-relative vx-p-6 xl:vx-p-10 vx-max-w-2xl">
            <h2 class="vx-mb-2 vx-text-xl vx-font-bold">
                Overview
                <font-awesome-icon :icon="faTelescope"></font-awesome-icon>
            </h2>
            <p class="vx-text-sm vx-mb-3 vx-font-sans vx-text-slate-700 lg:vx-text-base">
                <template v-if="props.templateView">
                    Snippet Templates are Snippets that can be shared with Groups. This allows you to draft resuable Snippets that individual Groups can make use of in their Campaigns and Quick Blast messages.
                </template>
                <template v-else>
                    Snippets are reusable pieces of content that bring speed and consistency to the message creation process. Use them in places like Message Hub, Campaigns, Quick Blast or anywhere you write messages.
                </template>
            </p>
            <a :href="docsLink"
               target="_blank"
               rel="noopener noreferrer"
               class="vx-text-sm vx-font-sans vx-font-normal vx-text-sky-500 vx-underline lg:vx-text-base">
                See Docs for More
                <font-awesome-icon class="vx-ml-2"
                                   :icon="faArrowRightLong"></font-awesome-icon>
            </a>
        </div>
    </vx-box-glass>
</template>

<script setup>
import {
    VxBoxGlass,
    VxWallpaper
} from "@voxie/frontend-components";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faArrowRightLong } from '@fortawesome/pro-solid-svg-icons';
import { faTelescope, faNotebook } from '@fortawesome/pro-regular-svg-icons';

const props = defineProps({
    templateView: {
        type: Boolean,
        default: false,
    }
});

const docsLink = props.templateView ?
    'https://support.voxie.com/hc/en-us/articles/31508847971597-Snippet-Templates' :
    'https://support.voxie.com/hc/en-us/articles/28472234017037-Snippets';
</script>
